export default "__VITE_ASSET__ee8fa7a1__"